export function modelToViewModelDayTimeTargets(targets, resetId = false) {
  const schedulingRows = [];

  targets.forEach((target) => {
    const criterion = target.Criterion;
    const multiplier = target.CriterionBid.Multiplier;

    schedulingRows.push({
      Id: resetId ? '' : target.Id,
      Day: criterion.Day,
      StartHour: criterion.FromHour,
      StartMinute: criterion.FromMinute,
      EndHour: criterion.ToHour,
      EndMinute: criterion.ToMinute,
      BidAdjustmentType: multiplier < 0 ? -1 : 1,
      BidAdjustmentAmount: window.Math.abs(multiplier),
    });
  });

  return schedulingRows;
}
